// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.photo-editor-beautify-button.disabled,
.photo-editor-beautify-button[disabled] {
  border-color: #adb3b8 !important;
  color: #adb3b8 !important;
}
.photo-editor-beautify-modal .modal-dialog {
  background-color: #ffffff73;
  width: 800px;
}
.photo-editor-beautify-modal .modal-dialog #photo-editor {
  height: 85vh;
  min-height: 600px;
  width: 800px;
}
`, "",{"version":3,"sources":["webpack://./app/components/common/photo-editor-beautify/photo-editor-beautify-button.less"],"names":[],"mappings":"AAOI;;EACI,gCAAA;EACA,yBAAA;AALR;AASA;EAGQ,2BAAA;EACA,YAAA;AATR;AAKA;EAOY,YAAA;EACA,iBAAA;EACA,YAAA;AATZ","sourcesContent":["//\n// Copyright (c) 2011-2019 by Curalate, Inc.\n//\n\n@import (reference) '../../../css/unison';\n\n.photo-editor-beautify-button {\n    &.disabled, &[disabled] {\n        border-color: @cu-gray-5 !important;\n        color: @cu-gray-5 !important;\n    }\n}\n\n.photo-editor-beautify-modal {\n\n    .modal-dialog {\n        background-color: #ffffff73;\n        width: 800px;\n\n        #photo-editor {\n            height: 85vh;\n            min-height: 600px;\n            width: 800px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
